import styled from '@emotion/styled/macro';
import { Variables } from '../../../base/variables';
import * as Shared from '../form.styles';

// Reused from facility-form.styles.tsx
export const FormContainer = Shared.FormContainer;
export const FormGrid = styled(Shared.FormGrid)`
    grid-template-columns: repeat(3, 1fr);
`;
export const FormField = Shared.FormField;
export const Label = Shared.Label;
export const Input = Shared.Input;

export const SavingIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: ${Variables.Colors.n15_24};
    border-radius: 4px;
    font-size: 12px;
    color: ${Variables.Colors.n70};
`;

